import {
    Module,
    VuexModule,
    getModule,
    Mutation,
} from 'vuex-module-decorators';
import store from '~common-store';
import { HomesSecurityState, HomeSecurity } from '~/interfaces/homeSecurity.interface';
import { HomesModule } from './homes';

@Module({ dynamic: true, store, name: 'homesSecurity', namespaced: true })
class HomesSecurity extends VuexModule implements HomesSecurityState {
    homesSecurity: HomeSecurity[] = [];


    get currentSecurityHome() {
        return this.homesSecurity.find((home) => home.homeId === HomesModule.currentHomeId);
    }

    get infoGeneral() {
        if (this.currentSecurityHome) {
            return [
                { key: 'gone_after', value: this.currentSecurityHome.gone_after, type: 'duration' },
                { key: 'share_info', value: this.currentSecurityHome.share_info, type: 'boolean' },
                { key: 'smart_notifs', value: this.currentSecurityHome.smart_notifs, type: 'boolean' },
                {
                    key: 'events_ttl',
                    value: this.currentSecurityHome.events_ttl,
                    type: 'frequency',
                },
            ];
        }
    }

    get infoPresence() {
        if (this.currentSecurityHome && this.currentSecurityHome.NOC) {
            const fromToAllDay =
                this.currentSecurityHome.NOC.notification_begin === 0
                && this.currentSecurityHome.NOC.notification_end === 0;
            return [
                { key: 'record_movements', value: this.currentSecurityHome.NOC.record_movements, type: 'alert_record' },
                { key: 'notify_movements', value: this.currentSecurityHome.NOC.notify_movements, type: 'alert_record' },
                { key: 'record_humans', value: this.currentSecurityHome.NOC.record_humans, type: 'alert_record' },
                { key: 'notify_humans', value: this.currentSecurityHome.NOC.notify_humans, type: 'alert_record' },
                {
                    key: 'record_animals',
                    value: this.currentSecurityHome.NOC.record_animals,
                    type: 'alert_record',
                },
                {
                    key: 'notify_animals',
                    value: this.currentSecurityHome.NOC.notify_animals,
                    type: 'alert_record',
                },
                {
                    key: 'record_vehicles',
                    value: this.currentSecurityHome.NOC.record_vehicles,
                    type: 'alert_record',
                },
                {
                    key: 'notify_vehicles',
                    value: this.currentSecurityHome.NOC.notify_vehicles,
                    type: 'alert_record',
                },
                {
                    key: 'notify_from',
                    value: fromToAllDay ? 'All day long' : this.currentSecurityHome.NOC.notification_begin,
                    type: fromToAllDay ? 'string' : 'duration',
                },
                {
                    key: 'notify_to',
                    value: fromToAllDay ? 'All day long' : this.currentSecurityHome.NOC.notification_end,
                    type: fromToAllDay ? 'string' : 'duration',
                },
                {
                    key: 'enable_notify_from_to',
                    value: this.currentSecurityHome.NOC.enable_notification_range,
                    type: 'alert_record',
                },
            ];
        }
    }

    get infoWelcome() {
        if (this.currentSecurityHome && this.currentSecurityHome.NACamera) {
            return [
                { key: 'record_movements', value: this.currentSecurityHome.NACamera.record_movements, type: 'alert_record' },
                { key: 'notify_movements', value: this.currentSecurityHome.NACamera.notify_movements, type: 'alert_record' },
                { key: 'record_alarms', value: this.currentSecurityHome.NACamera.record_alarms, type: 'alert_record' },
                { key: 'record_animals', value: this.currentSecurityHome.NACamera.record_animals, type: 'alert_record'},
                { key: 'notify_animals', value: this.currentSecurityHome.NACamera.notify_animals, type: 'alert_record'},
                { key: 'record_humans', value: this.currentSecurityHome.NACamera.record_humans, type: 'alert_record' },
                { key: 'notify_humans', value: this.currentSecurityHome.NACamera.notify_humans, type: 'alert_record' },
                { key: 'notify_unknowns',
                    value: this.currentSecurityHome.NACamera.notify_unknowns, type: 'alert_record'},
            ];
        }
    }

    get infoDoorbell() {
        if (this.currentSecurityHome && this.currentSecurityHome.NDB) {

            return [
                { key: 'notify_humans', value: this.currentSecurityHome.NDB.notify_humans, type: 'alert_record' },
                { key: 'record_humans', value: this.currentSecurityHome.NDB.record_humans, type: 'alert_record' },
            ];
        }
    }

    get hasSiren() {
        // TODO has siren
        return this.currentSecurityHome && this.currentSecurityHome.NACamera;
    }
    get infoSiren() {
        if (this.currentSecurityHome && this.currentSecurityHome.NACamera && this.hasSiren) {
            return [
                { key: 'siren_sound_unknowns', value: this.currentSecurityHome.NACamera.siren_sound_unknowns, type: 'alert_record' },
                { key: 'siren_sound_humans', value: this.currentSecurityHome.NACamera.siren_sound_humans, type: 'alert_record' },
                { key: 'siren_sound_movements', value: this.currentSecurityHome.NACamera.siren_sound_movements, type: 'alert_record'},
                { key: 'siren_sound_animals',
                    value: this.currentSecurityHome.NACamera.siren_sound_animals, type: 'alert_record' },
            ];
        }
    }

    @Mutation
    ADD_HOME_SECURITY(homeSecurity: HomeSecurity) {
        this.homesSecurity.push(homeSecurity);
    }
}

export const HomesSecurityModule = getModule(HomesSecurity);
